function findInBranch(taxons, taxonPermalink) {
  let requestedTaxon = null;
  for (const taxon of taxons) {
    if (taxonPermalink === taxon.permalink) {
      requestedTaxon = taxon;
      break;
    }
    const result = findInBranch(taxon.taxons, taxonPermalink);
    if (result) {
      requestedTaxon = result;
      break;
    }
  }
  return requestedTaxon;
}

function findTaxon(taxonomies, taxonPermalink) {
  let requestedTaxon = null;
  for (const taxonomy of taxonomies) {
    const rootCategory = [taxonomy.root];
    const result = findInBranch(rootCategory, taxonPermalink);
    if (result) {
      requestedTaxon = result;
      break;
    }
  }
  return requestedTaxon;
}

export { findTaxon };
